export class DSDispatchToFieldTeamRequestModel {
    userId: string;
	region: string;
	rmhCode: string;
    wh: string;
    whLocation: string;
    requirmentType: string
    fileUrl: string;
    product: string;
    jsonString: string;
	isDispatched: string;
	mfgDate: string;
	expDate: string;
	//batch: string;
	invoice: string;
	year:number;
	IsExcel:Number;
	
}
export class DSDispatchToFieldTeamResponseModel {
    region: string;
    rmhName: string;
    rmhCode: string;
    productId: string;
    productName: string;
    cropId: number;
    cropName: string;
    whLocation: string;
    dispatchDate: string;
    expectedDeliveryDate: string
    dispatchQty: string;
    numberofbox: number;
	year: number;
}
export class DSDispatchToFieldTeamModel {
    AllocatedId: number;
	RequestNo :number;
	RequirementType: string;
	Region: string;
	ProductCode: string;
	ProductName : string;
	WHCode : string;
	WHLocation : string;
	RMH_Name : string;
	MIOMDOUserId : string;
	MIOMDOUserName : string;
	Designation : string;
	MIEUserId : string;
	MIEUserName : string;
	JAN : number;
	FEB : number;
	MAR : number;
    APR : number;
	MAY : number;
	JUN: number;
	JUL : number;
	AUG : number;
	SEP : number;
	OCT : number;
	NOV : number;
	DEC : number;
	AllocatedDate : string;
	PackSize : string;
	FinalAllotedQty : number;
	SampleAllocatedDate: string;
	ChallanNo : string;
	NoOfCases : number;
	BatchNo  : string;
    MFGDate : string;
	EXPDate  : string;
	LRNO  : string;
	LRDate  : string;
	TransPortName  : string;
	Status  : string;
	Year : number;
	RegionName:string;
	
}